'use client';
import { useRouter } from 'next/navigation';
import { ChevronLeft } from 'lucide-react';

export default function BackButton({ label = 'Назад' }: { label?: string }) {
  const router = useRouter();
  return (
    <button
      onClick={() => router.back()}
      className="flex items-center gap-1 text-sm text-text-secondary hover:text-brand transition-colors sm:hidden mb-4"
    >
      <ChevronLeft size={18} />
      {label}
    </button>
  );
}
